<template>
  <div class="myPostIndex">
    <div class="paginationBox">
      <el-pagination
        :page-size="postPageSize"
        :pager-count="11"
        :current-page="postPageNum"
        layout="prev, pager, next"
        :total="postPageTotle"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
    <div
      class="cont"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
    >
      <div class="dsbox">
        <el-cascader placeholder='请选择职位类型' :options="jobTypeOptions" clearable :show-all-levels="false" @change="changejobType"></el-cascader>
        <el-select v-model="selectsearlyYearArray.label" placeholder="请选择用户年薪范围" @change="changeSelectsearlyYearArray" >
          <el-option
            v-for="item in searlyYearArray"
            :key="item.value"
            :label="item.label"
            :value="item"
          ></el-option>
        </el-select>
         <el-select v-model="selectworkYearArray.label" placeholder="请选择用户工作年限" @change="changeSelectworkYearArray">
          <el-option
            v-for="item in workYearArray"
            :key="item.value"
            :label="item.label"
            :value="item"
          ></el-option>
        </el-select>
                 <el-select v-model="selectCity" placeholder="请选择用户所在城市" @change="changeCity">
          <el-option
            v-for="item in cityArray"
            :key="item.id"
            :label="item.value"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div class="tableCont">
        <el-table
          :data="postList"
          border
          style="width: 100%"
          :row-key="function(e){
                return e.id
            }"
        >
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column prop="city" label="城市" align="center"></el-table-column>
          <el-table-column prop="industry" label="行业" align="center"></el-table-column>
          <el-table-column prop="nickname" label="上传人昵称" align="center"></el-table-column>
          <el-table-column prop="phone" label="手机号码" align="center"></el-table-column>
          <el-table-column prop="jobType" label="职业类型" align="center"></el-table-column>
          <el-table-column prop="roleLable" label="工作年限" align="center">
            <template
              slot-scope="scope"
            >{{scope.row.workingLifeMin + '-' + scope.row.workingLifeMax + '年'}}</template>
          </el-table-column>
          <el-table-column prop="roleLevle" label="薪资水平" align="center">
            <template
              slot-scope="scope"
            >{{scope.row.minYearSalary + '-' + scope.row.maxYearSalary + '万（年薪）'}}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间" align="center"></el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="lookResume(scope.row)">查看该简历</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Config from "../config/index";
export default {
  name: "dhkList",
  props: {},
  data() {
    return {
      loading: false,
      postStatus: "1",
      postList: [],
      peoList: [],
      postPageNum: 1,
      postPageSize: 10,
      postPageTotle: 0,
      QrUrl: "",
      qrdialogVisible: false,
      dialogVisible: false,
      loading1: false,
      phone: "",
      jobTypeCode: '',
      jobType: '',
      jobTypeOptions: [],
      searlyYearArray: [
        {
          min: "",
          max: "",
          label: "不限",
          id: "1"
        },
        {
          min: "",
          max: 30,
          label: "30万以下",
          id: "2"
        },
        {
          min: 30,
          max: 50,
          label: "30-50万",
          id: "3"
        },
        {
          min: 50,
          max: 80,
          label: "50~80万",
          id: "4"
        },
        {
          min: 80,
          max: 150,
          label: "80~150万",
          id: "5"
        },
        {
          min: 150,
          max: 300,
          label: "150~300万",
          id: "6"
        },
        {
          min: 300,
          max: "",
          label: "300万以上",
          id: "7"
        }
      ],
      selectsearlyYearArray: {
        min: "",
        max: "",
        label: "不限",
        id: "1"
      },
      workYearArray: [
        {
          min: "",
          max: "",
          label: "不限",
          id: "1"
        },
        {
          min: 1,
          max: 3,
          label: "1-3年",
          id: "2"
        },
        {
          min: 3,
          max: 5,
          label: "3-5年",
          id: "3"
        },
        {
          min: 5,
          max: 8,
          label: "5-8年",
          id: "4"
        },
        {
          min: 8,
          max: 15,
          label: "8-15年",
          id: "5"
        },
        {
          min: 15,
          max: "",
          label: "15年以上",
          id: "6"
        }
      ],
      selectworkYearArray: {
        min: "",
        max: "",
        label: "不限",
        id: "1"
      },
      cityArray: [],
      selectCity:  {
                id: "1",
                code: "",
                value: "不限"
              }
    };
  },
  watch: {},
  created: function() {},
  methods: {
    getJobTypeArray: function() {
      let that = this;
      axios({
        method: "GET",
        url: Config.path + "/api/common/treedata/gettreeData"
      })
        .then(res => {
          if (res.data.success === "1") {
            that.gsArray(res.data.content);
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(err => {
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    },
    gsArray: function(list) {
      for (let i in list) {
        let item = list[i];
        item.label = item.name;
        item.value = item.name + "," + item.code;
        if (item.childrenlist) {
          item.children = item.childrenlist;
          for (let j in item.children) {
            let item2 = item.children[j];
            item2.label = item2.name;
            item2.value = item2.name + "," + item2.code;
            if (item2.childrenlist) {
              item2.children = item2.childrenlist;
              for (let k in item2.children) {
                let item3 = item2.children[k];
                item3.label = item3.name;
                item3.value = item3.name + "," + item3.code;
              }
            }
          }
        }
      }
      this.jobTypeOptions = list;
    },
    getHotCityList: function() {
      let that = this;
      let data = {
        type: "hotCity"
      };
      axios({
        method: "GET",
        url: Config.path + "/api/common/dict/getlist",
        params: data
      })
        .then(res => {
          if (res.data.success === "1") {
            that.cityArray = [
              {
                id: "1",
                code: "",
                value: "不限制"
              }
            ].concat(res.data.content);
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(err => {
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    },
    changeSelectsearlyYearArray: function (e) {
      this.selectsearlyYearArray = {
          min: e.min,
          max: e.max,
          label: e.label,
          id: e.id
        },
      this.pageNum = 1;
      this.getPostList();
    },
    changeSelectworkYearArray: function (e) {
      this.selectworkYearArray =  {
          min: e.min,
          max: e.max,
          label: e.label,
          id: e.id
        },
     this.pageNum = 1;
      this.getPostList();
    },
    ckmorePeople: function(id) {
      this.dialogVisible = true;
      this.getMoreUser(id);
    },
    changejobType: function (e) {
      if (e.length === 0) {
          this.jobTypeCode = ''
          this.jobType = ''
      } else {
        this.jobTypeCode = e[e.length - 1].split(',')[1]
        this.jobType = e[e.length - 1].split(',')[0]
      }
      this.pageNum = 1;
      this.getPostList();
    },
    changeCity: function (e) {
      this.selectCity = e
           this.pageNum = 1;
      this.getPostList();
    },
    handleCurrentChange: function(e) {
      this.postPageNum = e;
      this.getPostList();
    },
    getMoreUser: function(id) {
      let that = this;
      that.loading1 = true;
      let data = {
        userId: id
      };
      axios({
        method: "POST",
        url: Config.path + "/api/platform/user/getMyUserInvitation",
        headers: {
          token: localStorage.getItem("token"),
          "content-type": "application/json"
        },
        data: data
      })
        .then(res => {
          that.loading1 = false;
          if (res.data.success === "1") {
            that.peoList = res.data.content;
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(err => {
          that.loading = false;
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    },
    getPostList: function() {
      let that = this;
      that.loading = true;
      let data = {
        pageNum: that.postPageNum,
        pageSize: that.postPageSize
      };
      if (this.jobTypeCode !== '') {
        data.jobTypeCode = this.jobTypeCode
      }
      if (this.selectsearlyYearArray.label !== '不限') {
        data.minYearSalary = this.selectsearlyYearArray.min
        data.maxYearSalary = this.selectsearlyYearArray.max
      }
      if (this.selectworkYearArray.label !== '不限') {
        data.workingLifeMin = this.selectworkYearArray.min
        data.workingLifeMax = this.selectworkYearArray.max
      }
      if (this.selectCity.value !== '不限') {
        data.cityCode = this.selectCity.code
      }


      axios({
        method: "POST",
        url: Config.path + "/api/platform/resume/getPublicResume",
        headers: {
          token: localStorage.getItem("token"),
          "content-type": "application/json"
        },
        data: data
      })
        .then(res => {
          that.loading = false;
          if (res.data.success === "1") {
            that.postList = res.data.content.list;
            that.postPageTotle = res.data.content.total;
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(err => {
          that.loading = false;
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    },
    lookResume: function (e) {
      window.open(e.oldFileUrl)
    }
  },
  mounted: function() {
    this.getPostList();
    this.getJobTypeArray();
    this.getHotCityList();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.myPostIndex {
  width: 100vw;
  height: calc(100vh - 100px);
  padding-top: 1px;
  position: relative;
  .paginationBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    // background-color: rgb(83, 152, 133);
    width: max-content;
    padding: 5px 40px;
    z-index: 9999;
    border-radius: 10px;
    .el-pager {
      li {
        background: transparent;
        color: #ffffff;
      }

      .active {
        background: #fff;
        color: #5dc2d0;
      }
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;

      i {
        color: #ffffff;
      }
    }
  }

  .cont {
    width: calc(100% - 60px);
    height: calc(100vh - 200px);
    background-color: #ffffff;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 30px;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    overflow: hidden;
    overflow-y: scroll;

    // .selectCont {

    //     .el-radio-group {
    //         margin-left: 40px;

    //         .el-radio-button__inner {
    //             background-color: transparent;
    //             color: #fff;
    //         }

    //         .is-active {
    //             .el-radio-button__inner {
    //                 background-color: #ffffff;
    //                 color: #5DC2D0;
    //                 border-color: #5DC2D0;
    //             }
    //         }
    //     }
    // }

    // .tableCont {
    //     margin-top: 30px;

    //     * {
    //         background-color: transparent;
    //         color: #ffffff;
    //     }

    //     .el-table--group,
    //     .el-table--border {
    //         border: none;

    //         &:after {
    //             border: none;
    //         }
    //     }

    //     .el-table--group,
    //     .el-table--border {
    //         border: none;
    //     }

    //     .el-table--border th,
    //     .el-table--border td {
    //         border: none;
    //     }

    //     .el-table--group::after,
    //     .el-table--border::after,
    //     .el-table::before {
    //         height: 0;
    //         width: 0;
    //     }

    //     .el-table__header-wrapper {
    //         border-bottom: 1px solid #ffffff;
    //     }

    //     .el-table__body tr {
    //         >td {
    //             span {
    //                 margin: 0 5px;
    //             }
    //         }

    //         &:hover {
    //             >td {
    //                 background-color: #ffffff;

    //                 div {
    //                     color: #5DC2D0;
    //                 }

    //                 span {
    //                     color: #5DC2D0;
    //                     margin: 0 5px;
    //                 }
    //             }
    //         }
    //     }
    // }
  }
  .dsbox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
  }
}
</style>
